<template>
    <Line
        :chart-options="props.chartOptions"
        :chart-data="chartData"
        :chart-id="props.chartId"
        :plugins="props.plugins"
        :height="props.height"
        :width="props.width" />
</template>
<script setup lang="ts">
import { Line } from 'vue-chartjs'
import { Chart, registerables } from 'chart.js/dist/chart.mjs'
Chart.register(...registerables)

const props = defineProps({
  chartId: {
    type: String,
    default: 'line-chart'
  },
  width: {
    type: Number,
    default: 400
  },
  height: {
    type: Number,
    default: 0
  },
  cssClasses: {
    default: '',
    type: String
  },
  styles: {
    type: Object,
    default: () => {}
  },
  plugins: {
    type: Object as any,
    default: () => {}
  },
  labels: {
    type: Array<any>,
    default: () => []
  },
  datasets: {
    type: Array<any>,
    default: () => []
  },
  chartOptions: {
    type: Object,
    default: () => {}
  }
})
const chartData = {
  labels: props.labels,
  datasets: props.datasets
}
</script>
